import { createRoute } from '@tanstack/react-router';
import { rootRoute } from '@trashlab/sitesapp/src/routes/__root';
import { HowWeMeasureUpHeroSection } from '@trashlab/sitesapp/src/templates/redebins/components/how-we-measure-up/how-we-measure-up-hero-section';
import { HowWeMeasureUpContent } from '@trashlab/sitesapp/src/templates/redebins/components/how-we-measure-up/how-we-measure-up-content';
import { ReadyWhenYouAre } from '@trashlab/sitesapp/src/templates/redebins/components/shared/ready-when-you-are';
import { ServiceAreasSection } from '@trashlab/sitesapp/src/templates/redebins/components/shared/service-areas-section';

const HowWeMeasureUpPage = () => {
  return (
    <>
      <HowWeMeasureUpHeroSection />
      <HowWeMeasureUpContent />
      <ReadyWhenYouAre />
      <ServiceAreasSection />
    </>
  );
};

export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: '/how-we-measure-up',
  component: HowWeMeasureUpPage,
});

